import React, { useEffect, useMemo, useState } from 'react';
import { useIntl } from 'react-intl';

import { ButtonGroup } from '~/eds/src/components/ButtonGroup/ButtonGroup';

interface Props {
  showTooltip?: boolean;
  value: string | undefined;
  onChange: (updatedValue: string) => void;
}

const AndOrToggle = ({
  showTooltip = false,
  value: initialValue = '',
  onChange,
}: Props) => {
  const [value, setValue] = useState(initialValue);
  const intl = useIntl();

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const actions = useMemo(
    () =>
      ['and', 'or'].map((v) => ({
        status: value === v ? ('active' as const) : undefined,
        text:
          v === 'and'
            ? intl.formatMessage({
                id: 'AndOrToggle.and',
                defaultMessage: 'AND',
                description: 'And query operator',
              })
            : intl.formatMessage({
                id: 'AndOrToggle.or',
                defaultMessage: 'OR',
                description: 'Or query operator',
              }),
        tooltip: showTooltip
          ? intl.formatMessage({
              id: 'AndOrToggle.preventInaccurateResults',
              defaultMessage:
                'To prevent returning inaccurate or incomplete results, use either all AND or all OR within a group.',
              description: 'Tooltip message for AND/OR toggle button group',
            })
          : '',
        onClick: () => {
          setValue(v);
          onChange(v);
        },
      })),
    [value, onChange, showTooltip],
  );

  return <ButtonGroup actions={actions} />;
};

export default AndOrToggle;
